import { CalendarTodayCard, InboxSummaryCard, SlaTodayCard } from '../../components/HomeWidgets';
import { LeaveBalanceCard } from './LeaveBalanceCard';

// 4-card "vital signs" row. Stacks single column on phones, 2 cols on small
// tablets, 4 cols on lg+. Each card is self-contained (independent fetch +
// independent error state) so a single 503 doesn't blank the whole row.

export const VitalSigns = () => (
  <section aria-label="At a glance" data-tour="widgets-row">
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 sm:gap-4 lg:grid-cols-4">
      <div data-tour="widget-today">
        <CalendarTodayCard />
      </div>
      <div data-tour="widget-inbox">
        <InboxSummaryCard />
      </div>
      <div data-tour="widget-sla">
        <SlaTodayCard />
      </div>
      <div data-tour="widget-leave">
        <LeaveBalanceCard />
      </div>
    </div>
  </section>
);
